export const PHONE = "(502) 963-2314";
export const PHONE_HREF = "tel:+15029632314";
export const EMAIL = "phillipswaterproofing@gmail.com";
export const FACEBOOK_URL = "https://www.facebook.com/PhillipsConcreteKY/";
export const LOGO = "/assets/phillips-logo.png";

export const prefillService = (service) =>
  window.dispatchEvent(new CustomEvent("prefill-service", { detail: service }));

const img = (id, w = 1200) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&q=80&w=${w}`;

export const HERO_IMG = img("photo-1541888946425-d81bb19240f5", 2000);

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Waterproofing", href: "#waterproofing" },
  { label: "Concrete", href: "#concrete" },
  { label: "Foundation Repair", href: "#services" },
  { label: "Projects", href: "#projects" },
  { label: "About", href: "#why" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#estimate" },
];

export const SERVICES = [
  { id: "basement-waterproofing", num: "01", title: "Basement Waterproofing", desc: "Long-term solutions for basement leaks, moisture, flooding, and water intrusion.", img: img("photo-1685464197644-41d9b07e1e73") },
  { id: "exterior-waterproofing", num: "02", title: "Exterior Waterproofing", desc: "Foundation excavation, waterproof membranes, drainage systems, and exterior protection.", img: img("photo-1621922688758-359fc864071e") },
  { id: "foundation-repair", num: "03", title: "Foundation Repair", desc: "Repair foundation cracks, structural movement, settling, and damaged foundation walls.", img: img("photo-1706660143732-c1d14701114e") },
  { id: "concrete-driveways", num: "04", title: "Concrete Driveways", desc: "New concrete driveways and full driveway replacement, built for Kentucky seasons.", img: img("photo-1628744448839-170bf324f27e") },
  { id: "patios-outdoor", num: "05", title: "Patios & Outdoor Concrete", desc: "Custom patios, walkways, steps, slabs, and outdoor concrete surfaces.", img: img("photo-1600573472592-401b489a3cdc") },
  { id: "concrete-repair", num: "06", title: "Concrete Repair", desc: "Repair cracked, damaged, deteriorated, or uneven concrete before it spreads.", img: img("photo-1546816077-623b4eaab352") },
  { id: "drainage-solutions", num: "07", title: "Drainage Solutions", desc: "French drains, sump systems, water diversion, and moisture control.", img: img("photo-1620385019253-b051a26048ce") },
];

export const PROBLEMS = [
  { id: "water-basement", title: "Water in My Basement", desc: "Leaks, damp walls, puddles, or flooding after rain.", service: "Basement Waterproofing" },
  { id: "foundation-cracks", title: "Cracks in My Foundation", desc: "Stair-step cracks, bowing walls, or visible settling.", service: "Foundation Repair" },
  { id: "damaged-driveway", title: "My Driveway Is Damaged", desc: "Cracked, spalling, or heaving concrete at the curb.", service: "Driveway" },
  { id: "new-patio", title: "I Need a New Patio", desc: "A clean, custom outdoor space built to last.", service: "Patio" },
  { id: "pooling-water", title: "Water Pools Around My House", desc: "Standing water near the foundation or in the yard.", service: "Drainage" },
  { id: "sinking-concrete", title: "My Concrete Is Sinking", desc: "Uneven slabs, trip hazards, and settled sections.", service: "Concrete Repair" },
];

export const SERVICE_OPTIONS = [
  "Basement Waterproofing",
  "Exterior Waterproofing",
  "Foundation Repair",
  "New Concrete",
  "Concrete Repair",
  "Driveway",
  "Patio",
  "Drainage",
  "Other",
];

export const SHOWCASE = [
  { title: "New Driveways", tag: "Concrete", img: img("photo-1605146769289-440113cc3d00") },
  { title: "Patios", tag: "Outdoor Living", img: img("photo-1512917774080-9991f1c4c750") },
  { title: "Sidewalks", tag: "Flatwork", img: img("photo-1781637202423-33ec5b47e52e") },
  { title: "Steps", tag: "Formed Concrete", img: img("photo-1620902740358-c07fe4916812") },
  { title: "Slabs", tag: "Structural", img: img("photo-1504307651254-35680f356dfd") },
  { title: "Decorative Concrete", tag: "Finishes", img: img("photo-1565626424178-c699f6601afd") },
  { title: "Commercial Concrete", tag: "Commercial", img: img("photo-1508450859948-4e04fabaa4ea") },
];

export const FILTERS = ["All", "Waterproofing", "Foundations", "Driveways", "Patios", "Concrete Repair", "Commercial"];

export const PROJECTS = [
  { title: "Basement Waterproofing System", category: "Waterproofing", city: "Louisville", img: img("photo-1685464197644-41d9b07e1e73", 900), ratio: "aspect-[4/5]" },
  { title: "Full Driveway Replacement", category: "Driveways", city: "Mount Washington", img: img("photo-1605146769289-440113cc3d00", 900), ratio: "aspect-[4/3]" },
  { title: "Foundation Wall Repair", category: "Foundations", city: "Bardstown", img: img("photo-1706660143732-c1d14701114e", 900), ratio: "aspect-square" },
  { title: "Backyard Patio Build", category: "Patios", city: "Elizabethtown", img: img("photo-1600573472592-401b489a3cdc", 900), ratio: "aspect-[4/3]" },
  { title: "Exterior Excavation & Membrane", category: "Waterproofing", city: "Shepherdsville", img: img("photo-1621922688758-359fc864071e", 900), ratio: "aspect-[4/5]" },
  { title: "Commercial Flatwork", category: "Commercial", city: "Lexington", img: img("photo-1486406146926-c627a92ad1ab", 900), ratio: "aspect-[4/3]" },
  { title: "Concrete Crack Repair", category: "Concrete Repair", city: "Frankfort", img: img("photo-1546816077-623b4eaab352", 900), ratio: "aspect-square" },
  { title: "New Concrete Driveway", category: "Driveways", city: "Jeffersontown", img: img("photo-1781637202423-33ec5b47e52e", 900), ratio: "aspect-[4/5]" },
  { title: "French Drain Installation", category: "Waterproofing", city: "Taylorsville", img: img("photo-1620385019253-b051a26048ce", 900), ratio: "aspect-[4/3]" },
  { title: "Outdoor Living Space", category: "Patios", city: "Shelbyville", img: img("photo-1512917774080-9991f1c4c750", 900), ratio: "aspect-[4/5]" },
  { title: "Foundation Excavation", category: "Foundations", city: "Georgetown", img: img("photo-1531834685032-c34bf0d84c77", 900), ratio: "aspect-[4/3]" },
  { title: "Concrete Surface Repair", category: "Concrete Repair", city: "La Grange", img: img("photo-1517581177682-a085bb7ffb15", 900), ratio: "aspect-square" },
];

export const WHY_ITEMS = [
  { num: "01", title: "Experience You Can See", desc: "Real crews, real projects, real results. Our work speaks before we ever do." },
  { num: "02", title: "Solutions Designed to Last", desc: "We fix the source of the problem — permanent solutions, not temporary patches." },
  { num: "03", title: "Clear Communication", desc: "You understand the problem, the solution, and every step of the process before work begins." },
  { num: "04", title: "Residential & Commercial", desc: "Equipped for homeowner projects and larger commercial jobs with the same standard of care." },
  { num: "05", title: "Work We Stand Behind", desc: "Lifetime warranty options available on qualifying systems. We put our name on every job." },
];

export const STATS = [
  { label: "Years of Experience", value: 15, suffix: "+" },
  { label: "Projects Completed", value: 500, suffix: "+" },
  { label: "5-Star Reviews", value: 100, suffix: "+" },
  { label: "Communities Served", value: 25, suffix: "+" },
];

export const CITIES = [
  "Louisville", "Jeffersontown", "St. Matthews", "Shepherdsville", "Mount Washington",
  "Hillview", "Bardstown", "Elizabethtown", "Radcliff", "Shelbyville", "La Grange",
  "Crestwood", "Prospect", "Taylorsville", "Frankfort", "Georgetown", "Lexington", "Lebanon",
];

export const MAP_PINS = [
  { city: "Louisville", x: 56, y: 34 },
  { city: "Shelbyville", x: 62, y: 40 },
  { city: "Frankfort", x: 66, y: 44 },
  { city: "Lexington", x: 73, y: 52 },
  { city: "Bardstown", x: 55, y: 55 },
  { city: "Elizabethtown", x: 47, y: 52 },
];
